/* styles */
import style from '@styles/plp/CircleLoader.module.scss';

export default function CircleLoader() {
    return <div className={style.loaderContainer}><div className={style.loader}></div></div>
}